// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"4966b63d","344":"d09e593b","369":"2368d8c1","486":"ee1016f3","667":"59c9e019","977":"40762712"}[chunkId] + ".chunk.js";
};